import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { BenefitsSection } from './components/BenefitsSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { HowToUseSection } from './components/HowToUseSection';
import { CompatibilitySection } from './components/CompatibilitySection';
import { IncludedSection } from './components/IncludedSection';
import { TrustSection } from './components/TrustSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { initFacebookPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return <main className="w-full min-h-screen bg-dark-900 text-white overflow-x-hidden" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1136780540633633&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <DifferentiatorSection data-id="element-6" />
      <HowToUseSection data-id="element-7" />
      <CompatibilitySection data-id="element-8" />
      <IncludedSection data-id="element-9" />
      <TrustSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />

      {/* Simple Footer */}
      <footer className="py-8 text-center text-gray-600 text-sm bg-dark-900 border-t border-white/5" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} Gel Gold. Todos los derechos reservados.
        </p>
      </footer>
    </main>;
}